import {
  z,
  ZodTypeAny,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodEffects,
  ZodCatch,
  ZodBranded,
  ZodLazy,
} from 'zod/v3';

/**
 * Peels away zod-wrappers until we reach the base zod type.
 */
export function unwrapZodSchema(schema: ZodTypeAny): z.AnyZodObject {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (schema instanceof ZodOptional) {
      schema = schema.unwrap();
    } else if (schema instanceof ZodNullable) {
      schema = schema.unwrap();
    } else if (schema instanceof ZodDefault) {
      schema = schema.removeDefault();
    } else if (schema instanceof ZodCatch) {
      // @ts-ignore accessing internal field
      schema = schema._def.innerType;
    } else if (schema instanceof ZodBranded) {
      // @ts-ignore accessing internal field
      schema = schema._def.type;
    } else if (schema instanceof ZodLazy) {
      // @ts-ignore accessing internal field
      schema = schema._def.getter();
    } else if (schema instanceof ZodEffects) {
      // @ts-ignore accessing internal field
      schema = schema._def.schema;
    } else {
      return schema as z.AnyZodObject;
    }
  }
}
